module.exports = __webpack_public_path__ + "img/female-youngchild-figure.049fa6ad.svg";